module.exports = __webpack_public_path__ + "img/mastercard2.4c19ec9c.svg";